import { useSelector } from 'react-redux';
import { AutocompleteFilter, SelectFilter } from '../../common/FiltersComponent';
import { CANCELLED_INVOICE_STATUS } from 'app/main/apps/e-commerce/shared/CustomerFilter';
import { containerStatusOptions } from './ordersTab/containerShipmentsShared';

export function OrdersTypeFilter({ column, params, updateParams }) {
  const orderTypeNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.orderTypeNames
  );
  return <SelectFilter multiple={false} column={column} menuData={orderTypeNames} params={params} updateParams={updateParams} />;
}

export function ShipmentTypeFilter({ column, params, updateParams }) {
  const shipmentTypeNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.shipmentTypeNames
  );
  return <SelectFilter multiple={false} column={column} menuData={shipmentTypeNames} params={params} updateParams={updateParams} />;
}

export function ShipToFilter({ column, params, updateParams }) {
  const shipToNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.shipToNames
  );
  return <SelectFilter multiple={false} column={column} menuData={shipToNames} params={params} updateParams={updateParams} />;
}

export function RequestedByFilter({ column, params, updateParams }) {
  const requestedByNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.requestedByNames
  );
  return <SelectFilter multiple={false} column={column} menuData={requestedByNames} params={params} updateParams={updateParams} />;
}


/**
 * PGSS-5371: the invoice Status filter on the SUPPLIER invoice list.
 *
 * Nothing cancels a supplier invoice — the cancel action exists only on the customer invoice — so
 * offering "Invoice Cancelled" there is a choice that can only ever return an empty list. Raised by
 * QA after the first version gated the option on role alone, and the supplier invoice list is
 * staff-facing.
 */
export function SupplierInvoiceStatusFilter({ column, params, updateParams }) {
  const orderStatusesNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.orderStatusesNames
  );
  const menuData = (orderStatusesNames || []).filter(
    (name) => String(name ?? '').trim().toLowerCase() !== CANCELLED_INVOICE_STATUS.toLowerCase()
  );
  return <SelectFilter multiple={false} column={column} menuData={menuData} params={params} updateParams={updateParams} />;
}

function OrdersSelectFilter({ column, params, updateParams }) {
  const orderStatusesNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.orderStatusesNames
  );
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const menuData = containerStatusOptions(orderStatusesNames, column.type, search);
  return <SelectFilter multiple={column.type === 'order'} column={column} menuData={menuData} params={params} updateParams={updateParams} />;
}

// Filter select condition for load capacity status
export function LoadSelectFilter({ column, params, updateParams }) {
  const loadStatusesNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.loadStatusesNames
  );
  return <SelectFilter multiple={column.type === 'container-management'} column={column} menuData={loadStatusesNames} params={params} updateParams={updateParams} />;
}

// Filter select condition for container shipment status
export function OrdersContainerShipmentFilter({ column, params, updateParams }) {
  const containerShipmentNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.containerShipmentNames
  );
  return <SelectFilter multiple={column.type === 'container-management'} column={column} menuData={containerShipmentNames} params={params} updateParams={updateParams} />;
}

export function PaymentSelectFilter({ column, params, updateParams }) {
  return <SelectFilter column={column} menuData={['paid', 'pending']} params={params} updateParams={updateParams} />;
}

export function PaymentTypeFilter({ column, params, updateParams }) {
  const paymentTypeNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.paymentTypeNames
  );
  return <SelectFilter multiple column={column} menuData={paymentTypeNames} params={params} updateParams={updateParams} />;
}

export function ContainerNumberFilter({ column, params, updateParams }) {
  const containerNumbers = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.containerNumbers
  );
  return <AutocompleteFilter multiple={false} column={column} menuData={containerNumbers} params={params} updateParams={updateParams} />;
}

export default OrdersSelectFilter;
